// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"e78020db","379":"c7a6bb48","463":"ce448472","488":"6330716d","524":"e398df3d","612":"d37e24d3","801":"10378b56"}[chunkId] + ".chunk.js";
};